import {
  Box,
  Button,
  Flex,
  ScaleFade,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useDisclosure,
} from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import { FiBarChart, FiTool } from 'react-icons/fi';

import { HeaderUp } from '../../../../components/_components_0.2/Header_0.2';
import { ModalConfigBI } from '../../../../components/_components_0.2/Modal/ModalConfigBI';
import { ModalGroupBI } from '../../../../components/_components_0.2/Modal/ModalGroupBI';
import { ModalReportBI } from '../../../../components/_components_0.2/Modal/ModalReportBI';
import { Sidebar } from '../../../../components/_components_0.2/Sidebar_0.2';
import {
  groupBiReports,
  useBiCatalog,
  useBiGroups,
} from '../../../../hooks/useBi';
import { BiConfig, BiReport } from '../../../../services/biService';
import { ConfigsTab } from './ConfigsTab';
import { ReportsTab } from './ReportsTab';
import { CardButton, CardeHeader, Container } from './styles';
import { useBiConfigs, useBiPermissions, useBiUsers } from './useBiAdminData';

export default function BusinessIntelligenceManagement() {
  const [tab, setTab] = useState(0);

  const reportModal = useDisclosure();
  const configModal = useDisclosure();
  const groupModal = useDisclosure();
  const [editingReport, setEditingReport] = useState<BiReport | undefined>();
  const [editingConfig, setEditingConfig] = useState<BiConfig | undefined>();
  const [editingGroup, setEditingGroup] = useState('');

  const catalog = useBiCatalog();
  const { byName } = useBiGroups();
  const configs = useBiConfigs();
  const permissions = useBiPermissions();
  const users = useBiUsers();

  const reports = useMemo(() => catalog.data || [], [catalog.data]);
  const groupNames = useMemo(
    () =>
      groupBiReports(reports)
        .map(item => item.group)
        .filter(group => group !== 'Sem grupo'),
    [reports],
  );

  const openReport = (report?: BiReport) => {
    setEditingReport(report);
    reportModal.onOpen();
  };

  const openConfig = (config?: BiConfig) => {
    setEditingConfig(config);
    configModal.onOpen();
  };

  const openGroup = (name: string) => {
    setEditingGroup(name);
    groupModal.onOpen();
  };

  return (
    <>
      <HeaderUp path="adm" />

      <Flex w="100%" maxWidth={1480} mx="auto" pb={4} px="6">
        <Sidebar path="adm" />

        <Box flex="1" minW="0">
          <ScaleFade initialScale={0.9} in>
            <Container>
              <CardeHeader>
                <div>
                  <h2>Inteligência de negócios</h2>
                  <strong>
                    Gerencie seus grupos de análise, permissões e configurações
                    do Power BI
                  </strong>
                </div>

                <CardButton>
                  <Button
                    leftIcon={<FiBarChart />}
                    onClick={() => openReport()}
                    type="button"
                    colorScheme="blue"
                    color="white"
                  >
                    Adicionar nova análise
                  </Button>
                  <Button
                    leftIcon={<FiTool />}
                    onClick={() => openConfig()}
                    type="button"
                    colorScheme="blue"
                    color="white"
                  >
                    Adicionar nova config. de BI
                  </Button>
                </CardButton>
              </CardeHeader>

              <Tabs variant="enclosed" index={tab} onChange={setTab} isLazy>
                <TabList>
                  <Tab>Painéis de análises</Tab>
                  <Tab>Configurações de PBI</Tab>
                </TabList>
                <TabPanels>
                  <TabPanel px="0">
                    <ReportsTab
                      catalog={catalog}
                      groups={byName}
                      permissions={permissions.data || []}
                      onEditReport={openReport}
                      onEditGroup={openGroup}
                    />
                  </TabPanel>
                  <TabPanel px="0">
                    <ConfigsTab
                      configs={configs}
                      reports={reports}
                      onEdit={openConfig}
                    />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Container>
          </ScaleFade>
        </Box>
      </Flex>

      <ModalReportBI
        isOpen={reportModal.isOpen}
        onClose={reportModal.onClose}
        report={editingReport}
        groups={groupNames}
        configs={configs.data || []}
        permissions={permissions.data || []}
        users={users.data || []}
      />

      <ModalConfigBI
        isOpen={configModal.isOpen}
        onClose={configModal.onClose}
        config={editingConfig}
      />

      <ModalGroupBI
        isOpen={groupModal.isOpen}
        onClose={groupModal.onClose}
        name={editingGroup}
        group={byName[editingGroup]}
        sample={reports.find(
          report => (report.groupNameSamasc || 'Sem grupo') === editingGroup,
        )}
      />
    </>
  );
}
